import { reactive } from 'vue';

export type DialogType = 'alert' | 'confirm' | null;

export interface DialogState {
  type: DialogType;
  title: string;
  message: string;
  variant: 'info' | 'success' | 'warning' | 'error';
  confirmLabel?: string;
  cancelLabel?: string;
  resolve: ((value: boolean) => void) | null;
}

const state = reactive<DialogState>({
  type: null,
  title: '',
  message: '',
  variant: 'info',
  resolve: null,
});

export function useAppDialog() {
  function showAlert(message: string, options?: { title?: string; variant?: DialogState['variant'] }) {
    return new Promise<void>((resolve) => {
      state.type = 'alert';
      state.title = options?.title ?? 'Message';
      state.message = message;
      state.variant = options?.variant ?? 'info';
      state.resolve = () => {
        state.type = null;
        state.resolve = null;
        resolve();
      };
    });
  }

  function showConfirm(
    message: string,
    options?: { title?: string; variant?: DialogState['variant']; confirmLabel?: string; cancelLabel?: string }
  ): Promise<boolean> {
    return new Promise((resolve) => {
      state.type = 'confirm';
      state.title = options?.title ?? 'Confirm';
      state.message = message;
      state.variant = options?.variant ?? 'warning';
      state.confirmLabel = options?.confirmLabel ?? 'OK';
      state.cancelLabel = options?.cancelLabel ?? 'Cancel';
      state.resolve = (ok: boolean) => {
        state.type = null;
        state.resolve = null;
        resolve(ok);
      };
    });
  }

  function close(value: boolean = false) {
    if (state.resolve) {
      state.resolve(value);
    } else {
      state.type = null;
    }
  }

  return {
    state,
    showAlert,
    showConfirm,
    close,
  };
}
